import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { CityService } from 'src/app/services/city.service';
import { OrderService } from 'src/app/services/order.service';
import { SystemService } from 'src/app/services/system.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-withdraw-by-delivery',
  templateUrl: './withdraw-by-delivery.component.html',
  styleUrls: ['./withdraw-by-delivery.component.scss'],
})
export class WithdrawByDeliveryComponent implements OnInit {
  form: FormGroup;
  citys: any[] = null;
  bond = null;
  coin = 0;
  fee = 0.00;
  minimumMount = 0.00;
  deliveryFee = 0.00;
  vm = false;
  amount;
  // pais: string = null;
  // lat;
  // longi;
  // positionInit: google.maps.LatLng;
  position: any[];

  constructor(private fb: FormBuilder, private toastCtrl: ToastController, private loadingCtrl: LoadingController,
                     private orderService: OrderService, private navCtrl: NavController, private cityService: CityService,
                     private systemService: SystemService) {
    this.form = this.fb.group({
      bondCoin: [],
      value: ['', Validators.compose([
        Validators.required,
      ])],
      phone: ['', Validators.compose([
        Validators.required
      ])],
      idCity: [0, Validators.compose([
        Validators.required
      ])],
      bondWithdraw: [],
      description: ['', Validators.compose([
        Validators.required,
        Validators.minLength(10)
      ])],
      house: ['', Validators.compose([
        Validators.required,
        Validators.minLength(10)
      ])],
      // latitude: ['', Validators.compose([
      //   Validators.required,
      // ])],
      // longitude: ['', Validators.compose([
      //   Validators.required,
      // ])],
    });
  }

  async ionViewDidEnter(){
    this.ngOnInit();
  }

  async ngOnInit() {
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.bond = Security.getCoin();

    if (this.bond === '1') {
      this.coin = 1;
    }

    if (this.bond === '2') {
      this.coin = 2;
    }

    if (this.bond === '3') {
      this.coin = 3;
    }

    this.systemService.getFeeWithdrawal().subscribe(result => {
      this.fee = result.data;
    });

    this.systemService.getMinimumWithdrawalAmount().subscribe(result => {
      this.minimumMount = result.data;
    });

    this.systemService.getFeeDelivery().subscribe(result => {
      this.deliveryFee = result.data;
    });

    this.cityService.get().subscribe(result => {
      if (result.success) {
        this.citys = result.data;
        loading.dismiss();
      }
    });

    this.form.patchValue({
      bondCoin: this.coin,
      bondWithdraw: 2,
    });
  }

  checkFeeDelivery(event){
    if(this.form.get('value').value < this.minimumMount ){
      this.vm = true;
    } else {
      this.vm = false;
    }
  }


  async withdraw() {
    const loading = await this.loadingCtrl.create({ message: 'Processando...' });
    loading.present();

    this.orderService.withdrawalByPartner(this.form.value).subscribe(result => {
      if (result.success) {
        this.showMessage(result.message);
        loading.dismiss();
        this.goToPage('/master/wallet/home');
      } else {
        this.showMessage(result.message);
        loading.dismiss();
      }
    }, error => {
      this.showMessage(error.message);
      loading.dismiss();
    });
  }


  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  goToPage(page: string) {
    this.navCtrl.navigateRoot(page);
  }
}
